import { Layout } from '@/components/Layout';
import { Page4XX } from '@/components/Page4XX';
import { ReactNode } from 'react';

export function with410(component: ReactNode, pageProps: any) {
  if (pageProps.isGone) {
    return <Layout content={<Page4XX status={410} />} />;
  }

  return component;
}
